module.exports = __webpack_public_path__ + "img/women-autonomy-border.181de126.svg";